<!--
 * @FileDescription: 退款失败提示对话框
 * @Author: 陈文景
 * @Date: 2022-11-07 18:11:51
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :visible.sync="visible" :width="`${width}px`" :before-close="close">
    <div class="tips">
      <i class="el-icon-error" />
      <p class="title">Refund Request Failed</p>
      <p class="subheading">
        There is error with you request<br />
        Please connect our support team
      </p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="medium" @click="confirm">OK</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      width: 500,
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },

    confirm() {
      this.close()
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {}
  }
}
</script>

<style lang="scss" scoped>
.tips {
  text-align: center;
  .el-icon-error {
    color: #a6100c;
    font-size: 45px;
  }
  .title {
    color: #000000;
    font-size: 20px;
    padding: 18px 0;
  }
  .subheading {
    color: #a6100c;
    font-size: 16px;
  }
}

/deep/.el-dialog {
  border-radius: 6px !important;
}

.dialog-footer {
  text-align: center;
}
</style>
